const LEGACY_ROLE_MAP: Record<string, string> = {
  role_root: 'admin',
  role_admin: 'admin',
  role_bank: 'bank',
  role_regulator: 'regulator',
  role_supervise: 'regulator',
  role_exchange: 'exchange',
  role_institution: 'exchange',
  role_exchange_operator: 'exchange_operator',
  role_institution_admin: 'exchange_operator',
  role_scenic: 'scenic',
  role_market_maker: 'market_maker',
  role_consumer: 'consumer',
};

export function normalizeRoleName(role: string): string {
  if (!role) return '';

  const normalized = role.trim().replace(/-/g, '_').toLowerCase();
  if (!normalized) return '';

  if (normalized === 'root') return 'admin';
  if (normalized === 'supervise') return 'regulator';
  if (normalized === 'institution') return 'exchange';
  if (normalized === 'exchange_operator' || normalized === 'institution_admin') return 'exchange_operator';

  if (LEGACY_ROLE_MAP[normalized]) {
    return LEGACY_ROLE_MAP[normalized];
  }

  return normalized;
}

export function normalizeRoleNames(roles: Array<string | null | undefined>): string[] {
  return Array.from(
    new Set(
      roles
        .map((role) => normalizeRoleName(role || ''))
        .filter(Boolean)
    )
  );
}

export function hasAnyAllowedRole(userRoles: Array<string | null | undefined>, allowedRoles: Array<string | null | undefined>): boolean {
  const normalizedUserRoles = normalizeRoleNames(userRoles);
  const normalizedAllowedRoles = new Set(normalizeRoleNames(allowedRoles));
  return normalizedUserRoles.some((role) => normalizedAllowedRoles.has(role));
}
